import { createRouter, createWebHashHistory } from 'vue-router';
const Login = () => import('./pages/Login.vue')
const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: "/",
        redirect: "/login"
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        exact: true,
        component: () => import('./pages/BioTechLeague_Dashboard/Dashboard.vue'),
        meta: {
            breadcrumb: [{ parent: '工作台', label: 'Home Page' }],
        },
    },
    {
        path: '/project',
        name: 'project',
        exact: true,
        component: () => import('./pages/BioTechLeague_Project/Project.vue'),
        meta: {
            breadcrumb: [{ parent: '工作台', label: 'Home Page' }],
        },
    },
    {
        path: '/SampleStatus',
        name: 'SampleStatus',
        exact: true,
        component: () => import('./pages/BioTechLeague_Sample_Status/Sample_Status.vue'),
        meta: {
            breadcrumb: [{ parent: '工作台', label: 'Home Page' }],
        },
    },
    {
        path: '/Contact',
        name: 'Contact',
        exact: true,
        component: () => import('./pages/BioTechLeague_Contact/Contact.vue'),
        meta: {
            breadcrumb: [{ parent: '工作台', label: 'Home Page' }],
        },
    },
]
const router = createRouter({
    history: createWebHashHistory(),
    routes: [...routes],
    scrollBehavior() {
        return { left: 0, top: 0 };
    }
});
router.beforeEach((to, from) => {
    // console.log(to.path);
    if (to.path !== "/login") {
        // console.log(localStorage)
        // if (localStorage.getItem('token')) {
        //     // next()
        //     return true
        // }
        // else {
        //     // alert('你没有权限')
        //     // router.push("/login")
        //     return false
        // }
    }
    // if (to.path == "/project"&&localStorage.getItem('isShowProject')!='Y'){
    //     router.replace("/Contact")
    // }
    if (to.path == "/SampleStatus"&&localStorage.getItem('isShowSample')!='Y'){
        router.replace("/project")
    }
    else {
        return true
    }
})
export default router;



